import axios from "axios";
import * as types from "./mutation-types";

/* eslint-disable */
export default {
    updateSearch({ commit }, payload) {
     commit(types.UPDATE_SEARCH, payload);
  },

   clearSearch({ commit }) {
     commit(types.CLEAR_SEARCH);
  },
};
